import React, {useContext} from 'react';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';
import UserInfo from '../../../../shared/components/UserInfo';
import Navigation from '../../Navigation/VerticleNav';
import {toggleNavCollapsed} from '../../../../redux/actions';
import {useDispatch, useSelector} from 'react-redux';
import Box from '@material-ui/core/Box';
import useStyles from './AppSidebar.style';
import Scrollbar from '../../Scrollbar';
import AppContext from '../../../utility/AppContext';
import {AppState} from '../../../../redux/store';
import AppContextPropsType from '../../../../types/AppContextPropsType';
import {LabelHorKeyValue} from 'modules/atoms';
import {useAuthToken} from '@crema/utility/AppHooks';

interface AppSidebarProps {
  position?: 'left' | 'bottom' | 'right' | 'top';
  variant?: string;
}

const AppSidebar: React.FC<AppSidebarProps> = ({
  position = 'left',
  variant = '',
}) => {
  const dispatch = useDispatch();
  const {navCollapsed} = useSelector<AppState, AppState['settings']>(
    ({settings}) => settings,
  );
  const {themeMode} = useContext<AppContextPropsType>(AppContext);

  const handleToggleDrawer = () => {
    dispatch(toggleNavCollapsed());
  };
  const classes = useStyles({themeMode});
  let sidebarClasses = classes.sidebarStandard;

  const [loading, user] = useAuthToken();

  console.log('Srecko - user - ', user);

  let ratingsKeys =
    user?.ratings !== undefined && user
      ? (Object.keys(user?.ratings) as Array<string>)
      : [];

  const isShipper = user?.roles.includes('Shipper');
  const isCarrier = user?.roles.includes('Carrier');

  console.log(user);

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor={position}
          open={navCollapsed}
          onClose={() => handleToggleDrawer()}
          classes={{
            root: clsx(variant),
            paper: clsx(variant),
          }}
          style={{position: 'absolute'}}>
          <Box height='100%' className={classes.container}>
            <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
              <UserInfo />
              <Scrollbar
                scrollToTop={false}
                className={classes.drawerScrollAppSidebar}>
                <Navigation />
              </Scrollbar>
            </Box>
          </Box>
        </Drawer>
      </Hidden>
      <Hidden mdDown>
        <Box height='100%' className={clsx(classes.container, 'app-sidebar')}>
          <Box className={clsx(classes.sidebarBg, sidebarClasses)}>
            <UserInfo />
            <Scrollbar
              scrollToTop={false}
              className={classes.scrollAppSidebar}
              style={{display: 'flex', flexDirection: 'column'}}>
              <Navigation />
              <Box
                style={{
                  marginTop: 'auto',
                  marginLeft: '20px',
                  marginBottom: '10px',
                }}>
                {(isCarrier || isShipper) &&
                  !loading &&
                  user?.ratings !== undefined &&
                  ratingsKeys.map((rating, index) => {
                    return (
                      <LabelHorKeyValue
                        key={rating}
                        title={rating + ':'}
                        value={'' + user.ratings![rating].toFixed(2)}
                        noSpacing
                      />
                    );
                  })}
              </Box>
            </Scrollbar>
          </Box>
        </Box>
      </Hidden>
    </>
  );
};

export default AppSidebar;
